import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DxDataGridModule } from 'devextreme-angular';
import { NgxMaskModule } from 'ngx-mask';
import { RxSearchModule } from '../../shared/components/rx-search/rx-search.module';
import { SharedModule } from '../../shared/shared.module';
import { LeaveofAbsenceComponent } from './leave-of-absence.component';
import { leaveOfAbsensceRoutes } from './leave-of-absence.routes';

@NgModule({
  imports: [
    RouterModule.forChild(leaveOfAbsensceRoutes),
    SharedModule,
    CommonModule,
    NgxMaskModule,
    ReactiveFormsModule,
    RxSearchModule,
    DxDataGridModule
  ],
  declarations: [
    LeaveofAbsenceComponent
  ]
})
export class LeaveofAbsenceModule {}
